import React, { Component } from 'react';
import './NewCollectionPage.css';
import '@shopify/polaris/dist/styles.css';
import { AppProvider } from '@shopify/polaris';
import Collection from '../components/Collection';
import { getFetch } from '../helpers/request';

interface NewCollectionPageProps {

}

interface NewCollectionPageState {
  shopOrigin: string
}

class NewCollectionPage extends Component <NewCollectionPageProps, NewCollectionPageState> {

  constructor(props: NewCollectionPageProps) {
    super(props);
    this.state = {
      shopOrigin: ''
    };
  }

  componentDidMount() {
    //check if log in
    getFetch('/app/api/shopify/user', {})
    .then((res:any) => res.json()
    ).then(data => {
      this.setState({ shopOrigin: data.shop_origin })
    }).catch(err => {

    });
  }

  render() {
    return (
      this.state.shopOrigin !== '' &&
      <AppProvider i18n={{}}>
        <Collection shopOrigin={this.state.shopOrigin} type="new"></Collection>
      </AppProvider>
    );
  }
}

export default NewCollectionPage;
